import React from 'react';

import { useForm } from 'react-hook-form';
import { BillingSettingType } from 'src/accounts/types';
import { Toast } from 'src/common/components';

import { updateBillingSetting } from '../api';
import { Action } from '../constants';
import { useAccountProfileContext } from '../context';

const BillingSetting: React.FC = () => {
  const { state, dispatch } = useAccountProfileContext();
  const { account } = state;
  const { billing_setting: billingSetting } = account;
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register, handleSubmit, reset } = useForm<BillingSettingType>({
    defaultValues: billingSetting,
  });

  const onSubmit = async (data: BillingSettingType): Promise<void> => {
    const payload = { ...data, id: billingSetting.id };
    try {
      await updateBillingSetting(payload);
      dispatch({
        type: Action.UPDATE_BILLING_SETTING,
        billingSetting: payload,
      });
      Toast.success('Changes saved successfully.');
    } catch (err) {
      Toast.error('There was an error saving changes.');
      reset(billingSetting);
    }
  };

  return (
    <form className="flex flex-col mt-6" onSubmit={handleSubmit(onSubmit)}>
      <div className="sm:grid sm:grid-cols-3 sm:gap-8 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
        <div className="sm:col-span-2">
          <h4>Is account delinquent</h4>
          <p className="helper-text">Set to True for accounts that is a delinquent.</p>
        </div>
        <input
          type="checkbox"
          className="w-5 h-5"
          {...register('is_delinquent')}
          data-testid="is-delinquent"
        />
      </div>
      <div className="sm:grid sm:grid-cols-3 sm:gap-8 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
        <div className="sm:col-span-2">
          <h4>Should ignore delinquent check</h4>
          <p className="helper-text">
            Set to true if we should not check if account has overdue invoice or missing
            subscription.
          </p>
        </div>
        <input
          type="checkbox"
          className="w-5 h-5"
          {...register('ignore_delinquent_check')}
          data-testid="ignore-delinquent-check"
        />
      </div>
      <button className="btn btn-secondary mt-4 ml-auto" type="submit" data-testid="submit">
        Save changes
      </button>
    </form>
  );
};

export default BillingSetting;
